<script>
import AccordionItemForeign from "./AccordionItemForeign";

export default {
  name: "AccordionForeign",
  components: { AccordionItemForeign },
  props: {
    content: Array,
    dataItem: Object,
  },
};
</script>
<template>
  <div class="accordion box" role="presentation">
    <accordion-item-foreign
      v-for="item in content"
      :item="item"
      :key="item.id"
      :dataItem="dataItem"
    >
    </accordion-item-foreign>
  </div>
</template>
